// react documenation used: https://react.dev/learn
// axios documentation used: https://axios-http.com/docs/intro
// ChatGPT code from home page resused for pagination
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Nav from "../../layout/navBar/navBar";
import Recent from "../../layout/recentBar/recentBar";
import styles from "./categoryPage.module.css";
import axios from "axios";
import CategoryDetailsPopup from "../../layout/categoryRepoDetails/categoryRepoDetails";

function CategoryPage() {
  const navigate = useNavigate();
  const { categoryName } = useParams();
  const [repositories, setRepositories] = useState([]);
  const [selectedRepo, setSelectedRepo] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const reposPerPage = 12;
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchCategoryRepositories = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(
          `${apiUrl}/api/requests/categories/${categoryName}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setRepositories(response.data);
      } catch (error) {
        console.error("Failed to fetch repositories:", error);
      }
    };

    fetchCategoryRepositories();
  }, [apiUrl, categoryName]);

  // functions to open and close repository detail cards
  const handleRepoSelect = (repo) => {
    setSelectedRepo(repo);
  };

  const handleClosePopup = () => {
    setSelectedRepo(null);
  };

  const handleBackToDiscoverClick = () => {
    navigate("/discoverPage");
  };

  // variables used to setup the pagination

  const lastRepoIndex = currentPage * reposPerPage;
  const firstRepoIndex = lastRepoIndex - reposPerPage;
  const currentRepos = repositories.slice(firstRepoIndex, lastRepoIndex);

  const getPlatformIcon = (url) => {
    if (url.includes("github.com")) {
      return "/github.png";
    } else if (url.includes("gitlab.com")) {
      return "/gitlab.png";
    } else {
      return null;
    }
  };

  return (
    <div>
      <Nav />
      <div className={styles.home}>
        <header className={styles.header}></header>
        <main className={styles.mainContent}>
          <section className={styles.recentlyAccessed}>
            <Recent />
          </section>

          <section className={styles.sharedRepositories}>
            <h2>Repositories in {categoryName}</h2>
            <button
              className={styles.goBackButton}
              onClick={handleBackToDiscoverClick}
            >
              Go Back
            </button>
            <div className={styles.reposContainer}>
              {currentRepos.map((repo, index) => (
                <div
                  key={index}
                  className={styles.repoCard}
                  onClick={() => handleRepoSelect(repo)}
                >
                  <img
                    src={getPlatformIcon(repo.repository_url)}
                    alt="Platform Icon"
                    style={{ width: "20px", marginRight: "10px" }}
                  />
                  {repo.repository_name}
                </div>
              ))}
            </div>
            <div className={styles.pagination}>
              <button
                onClick={() =>
                  setCurrentPage((prevPage) => Math.max(prevPage - 1, 1))
                }
                disabled={currentPage === 1}
                className={styles.pageNavButton}
              >
                Previous
              </button>

              {Array.from(
                { length: Math.ceil(repositories.length / reposPerPage) },
                (_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrentPage(i + 1)}
                    className={currentPage === i + 1 ? styles.active : ""}
                  >
                    {i + 1}
                  </button>
                )
              )}

              <button
                onClick={() =>
                  setCurrentPage((prevPage) =>
                    Math.min(
                      prevPage + 1,
                      Math.ceil(repositories.length / reposPerPage)
                    )
                  )
                }
                disabled={
                  currentPage === Math.ceil(repositories.length / reposPerPage)
                }
                className={styles.pageNavButton}
              >
                Next
              </button>
            </div>
          </section>
        </main>
        {selectedRepo && (
          <CategoryDetailsPopup
            repo={selectedRepo}
            onClose={handleClosePopup}
          />
        )}
      </div>
    </div>
  );
}

export default CategoryPage;
